<template>
  <div id="app">
    <!-- <app-home></app-home> -->
    <router-view />
  </div>
</template>

<script>
// import Home from '@/views/home/index.vue'
import { getQueryParamsByName } from '@/utils/index'
export default {
  name: 'App',
  // components: {
  //   'app-home': Home
  // }
  mounted(){
    // 获取地址栏的token，进行存储
    const association_token = getQueryParamsByName('association_token');
    console.log("_APP mounted", association_token)
    if (association_token) {
      localStorage.setItem("association_token", association_token);
    }
  }
}
</script>

<style lang="scss" scoped>
@import url(./assets/iconfont/iconfont.css);

#app {
  width: 100vw;
  height: 100vh;
  background-color: #010721;
  overflow: hidden;
}
</style>
